import {hasValue} from '@famly/stat_ts-utils_has-value';

/**
 * Optional options used to determine the behavior of the Debounced instance
 */
export type DebouncedOptions = {
    timeoutMs?: number;
};

export class Debounced<T extends (...args: any[]) => void> {
    private readonly cb: T;
    private timeout?: ReturnType<typeof setTimeout>;
    private timeoutMs: number = 500;

    constructor(callback: T, options?: DebouncedOptions) {
        this.cb = callback;

        if (hasValue(options)) {
            this.timeoutMs = options.timeoutMs ?? this.timeoutMs;
        }
    }

    public call = (...args: Parameters<T>) => {
        this.clearTimeout();
        this.timeout = setTimeout(() => this.execute(...args), this.timeoutMs);
    };

    private execute = (...args: Parameters<T>) => {
        this.clearTimeout();
        if (this.cb) {
            this.cb(...args);
        }
    };

    private clearTimeout = () => {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = undefined;
    };
}
